import type { NextRouter } from "@/shared/lib/router/router";

/**
 * Redireciona o usuário para o `link` de uma notificação.
 * - Links absolutos (http/https) abrem em nova aba.
 * - Links relativos ("/orders/123") navegam via router do Next, sem full reload.
 */
export function openNotificationLink(link: string | undefined | null, router: NextRouter): void {
    if (!link) return;
    const trimmed = link.trim();
    if (!trimmed) return;

    if (/^https?:\/\//i.test(trimmed)) {
        window.open(trimmed, "_blank", "noopener,noreferrer");
        return;
    }

    router.push(trimmed.startsWith("/") ? trimmed : `/${trimmed}`);
}
